import { useMemo } from 'react';

import TokenPoolsSlider from '@/components/global/TokenPoolsSlider';
import { T_TokenPool } from '@/ts/types/T_Profile';

type T_Variant = 'predictions' | 'pools' | 'referrals';

interface I_SectionHeaderProps {
  variant: T_Variant;
  predictionsInfoList: React.ReactNode;
  referralsInfoList: React.ReactNode;
  tokenPools: T_TokenPool[];
}

export function SectionHeader({
  variant,
  predictionsInfoList,
  referralsInfoList,
  tokenPools
}: I_SectionHeaderProps) {
  const sectionHeader = useMemo(() => {
    switch (variant) {
      case 'predictions':
        return predictionsInfoList;
      case 'pools':
        return tokenPools.length > 0 ? (
          <TokenPoolsSlider data={tokenPools} />
        ) : null;
      case 'referrals':
        return referralsInfoList;
      default:
        return;
    }
  }, [variant, predictionsInfoList, referralsInfoList, tokenPools]);

  return <>{sectionHeader}</>;
}
